import React from 'react';
import { StacklineColor, useStacklineTheme } from '@stackline/ui';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export interface LegendIndicatorProps {
  /**
   * Color of the legend indicator
   */
  color: StacklineColor;

  /**
   * The time period to display, e.g. "Jan 2, 2022 - Apr 9, 2022"
   */
  displayName: string;

  dashed?: boolean;

  subtitle?: React.ReactNode;

  showDot?: boolean;

  textColor?: StacklineColor;

  opacity?: number;

  legendOnClick?: () => void;

  legendOnHover?: (boolean) => void;
}

/**
 * Indicator with a color and a date corresponding to the
 * chart the legend is for
 */

const LegendIndicator = ({
  color,
  displayName,
  dashed,
  subtitle,
  textColor,
  showDot = true,
  opacity,
  legendOnClick,
  legendOnHover
}: LegendIndicatorProps) => {
  const theme = useStacklineTheme();

  const legendDot = (
    <div
      style={{
        backgroundColor: theme.colors[color],
        width: '5px',
        height: '3px',
        borderRadius: '10px'
      }}
    />
  );

  return (
    <Flex
      gap="sm"
      flexDirection="column"
      onClick={legendOnClick}
      style={legendOnClick ? { cursor: 'pointer' } : {}}
      onMouseEnter={legendOnHover}
      onMouseLeave={legendOnHover}
    >
      <Flex gap="sm" alignItems="center" sx={{ ...(opacity ? { opacity } : {}) }}>
        {showDot &&
          (dashed ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '12px'
              }}
            >
              {legendDot}
              {legendDot}
            </div>
          ) : (
            <div
              style={{
                width: '12px',
                height: '3px',
                borderRadius: '10px',
                backgroundColor: theme.colors[color]
              }}
            />
          ))}
        <Text variant="body2" color={textColor || 'primary'}>
          {displayName}
        </Text>
      </Flex>
      {subtitle &&
        (typeof subtitle === 'string' ? (
          <Text sx={{ paddingLeft: '20px' }} variant="body3">
            {subtitle}
          </Text>
        ) : (
          subtitle
        ))}
    </Flex>
  );
};

export default LegendIndicator;
